import React from 'react';
import PropTypes from 'prop-types';
import { assetPath, v as bvVar } from 'bv';

const { BvApi } = window;

const Ambassador = ({ hasBackground, showImage }) => {
  // Use the global variable ambassador with the globally available ambassador info
  const ambassador = bvVar('ambassador');

  if (!ambassador) return null;

  // =============================================================
  // Image to be shown only if showImage is true
  // Gradient background to be added only if hasBackground is true
  // Text always shown
  // =============================================================

  const className = hasBackground ? ' ambassador-container--bg' : '';

  return (
    <div className={`ambassador-container${className}`}>
      {showImage && (
        <div className="ambassador-container__img-wrapper">
          <img
            className="ambassador-container__img"
            src={assetPath(ambassador.image_url)}
            alt={ambassador.name}
          />
        </div>
      )}
      <div className="ambassador-container__inner">
        <div className="ambassador-container__title">{BvApi.t('ambassador')}</div>
        <div className="ambassador-container__name">{ambassador.name}</div>
      </div>
    </div>
  );
};

Ambassador.propTypes = {
  showImage: PropTypes.bool,
  hasBackground: PropTypes.bool,
};

Ambassador.defaultProps = {
  showImage: true,
  hasBackground: true,
};

export default Ambassador;
